module.exports.tickBoxElement = require('./context-menu-tick-box-element.tmpl.html');
module.exports.multipleElements = require('./context-menu-multiple-elements.tmpl.html');
module.exports.noSelection = require('./context-menu-no-selection.tmpl.html');
module.exports.textElement = require('./context-menu-text-element.tmpl.html');
module.exports.imageElement = require('./context-menu-image-element.tmpl.html');